module.exports = __webpack_public_path__ + "static/img/zjs.ad506ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/zjs.jpg
// module id = VCqC
// module chunks = 0